module.exports = __webpack_public_path__ + "img/cartoon.d719590b.jpg";